import React from "react";
import store from "@redux/store";
import { StoreContext } from "@frameworks/shared-library/components/customHooks/customUseSector";
var ComponentWithProvider = function (props) {
    return (
    //<Provider store={store}>
    React.createElement(StoreContext.Provider, { value: store }, props.component)
    //</Provider>
    );
};
export default ComponentWithProvider;
